<template>
	<div class="content">
		<div class="tableTit">
			<p class="tabtitBg"></p>
			<h6>巡检计划</h6>
			<el-button class="titBtn" type="primary" icon="el-icon-plus" @click="addClick()">添加计划</el-button>
			<el-button class="titBtn" type="success" @click="reset" icon="el-icon-refresh">重置</el-button>
			<el-button class="titBtn" type="success" icon="el-icon-search">搜索</el-button>
			<el-input class="querys" v-model.trim="dw" placeholder="名称"></el-input>
			<addressTree @obj="objdata"></addressTree>
		</div>
		<div class="tabBody">
			<el-table :data="tabledata" :height="tableHeight" border :header-cell-style="{background:'rgba(49,130,222,0.1)'}">
				<el-table-column type="index" align='center' width="60" label="序号"></el-table-column>
				<el-table-column prop="ydbXjjhMc" align='center' label="计划名称"></el-table-column>
				<!-- <el-table-column prop="option" align='center' label="巡检类型"></el-table-column> -->
				<el-table-column prop="ydbFxxczrr" align='center' label="负责人"></el-table-column>
				<el-table-column prop="ydbNames" align='center' width="600" label="巡检点"></el-table-column>
				<el-table-column prop="ydbXjrq" align='center' label="巡检日期"></el-table-column>
        <el-table-column prop="status" label="巡检状态" width="85px" align="center">
          <template slot-scope="scope">
            <p v-if="scope.row.status=='1'" class="zxfonte">未执行</p>
            <p v-if="scope.row.status=='0'" class="zxfontb"><span class="fa fa-check fafongt"></span>已执行</p>
          </template>
        </el-table-column>
				<el-table-column prop="" label="操作" width="110" align="center">
					<template slot-scope="scope">
						<!-- <el-button type="primary" icon="el-icon-view" circle @click="See(scope.$index,scope.row)" class="btnmargin"></el-button> -->
						<el-button type="warning" class="tableedit" icon="el-icon-delete" circle @click="Deletes(scope.row,scope.$index)"></el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="fye">
			<pagintion @dsydata='DsyData' @dstdata="DstData" :ToTal='total' :pageNums="pageNums"></pagintion>
		</div>

		<inspectionpopup v-if="dialogVisible == true" :mystate="Addsid" @getcancel="Getcancel" @adddata="Adddata"></inspectionpopup>
	</div>
</template>
<script>
  import { xjjhList, xjjhDelete } from "@/api/api";
	import addressTree from '@/components/mangement/addressTree.vue';
	import pagintion from '@/components/mangement/pagintion.vue'
	import inspectionpopup from '../popup/Inspectionpopup.vue'

	export default{
		data(){
			return{
				dw:'',
				tabledata: [],
				tableHeight: window.innerHeight - 180,
				total: 0,
				pageSize: 20, //每页多少条数据分页
				pageNum: 1, //当前页
				pageNums: null,
				username: '',
				dw: '',
				dialogVisible: false,
				Addsid: [],
				row: null,
			}
		},
		components: {
			addressTree,
			pagintion,
			inspectionpopup
		},
		mounted() {
      let params = {
      	pageSize: this.pageSize,
      	pageNum: this.pageNum,
      }
      this.list(params);
		},
		methods:{
      //调用接口获得防汛管理制度列表
      list(params) {
      	xjjhList(params).then((res) => {
          this.total = res.total;
          this.tabledata = res.data;
      	})
      },
			Adddata(data){
        this.dialogVisible = data.dialogVisible;
        let params={
        	pageSize: this.pageSize,
        	pageNum: this.pageNum,
        }
        this.list(params);
			},
			Getcancel(data){
        this.dialogVisible = data.dialogVisible;
			},
			addClick(){
        this.Addsid = [];
        this.dialogVisible = true;
        this.Addsid.push('xz');
			},
      // See(index, row) {
      //   this.Addsid = [];
      //   this.dialogVisible = true;
      //   this.Addsid.push('ck', row);
      // },
			Deletes(row, index) {
				this.$confirm('确定删除当前用户吗?此操作将永久删除, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(action => {
					if(action === 'confirm') {
			      let ids = [];
			      ids.push(row.id);
						xjjhDelete(ids).then((res) => {
							if(res.code == 200) {
								this.$notify({
									title: "提示",
									message: res.message,
									type: "success",
								});
								let params = {
									pageSize: this.pageSize,
									pageNum: this.pageNum,
								}
								this.list(params)
							} else {
								this.$notify({
									title: "提示",
									message: res.message,
									type: "success",
								});
							}
						})
					}
				}).catch(() => {
					this.$message({
						message: '已取消',
						type: 'warning'
					});
				});
			},
			reset(){
        this.dw = '';
			},
			objdata(){

			},
			DsyData(data) { //多少页
				this.pageNum = data.dsy;
				let params = {
					pageSize: this.pageSize,
					pageNum: this.pageNum,
				}
        this.list(params)
			},
			DstData(data) { //多少条
				this.pageSize = data.dst;
				let params = {
					pageSize: this.pageSize,
					pageNum: this.pageNum,
				}
        this.list(params)
			},
		}
	}

</script>

<style scoped>
	@import url('../../../common/css/mangementall.css');
	.querys {
		height: 30px;
		float: right;
		width: 200px;
		margin-top: 10px;
		margin-right: 10px;
	}

	>>>.el-input__inner {
		height: 30px;
		line-height: 30px;
		color: #606266;

		font-size: 14px;
	}
</style>
